'use strict';
const angular = require('angular');

/*@ngInject*/
export function HistoryService($resource) {
  return $resource('/api/histories/:id', {
    name: '@_id'
  },{
    getByEntity: {
      method: 'GET',
      url: "/api/histories/entity/:id",
      isArray: true
    },
    getInsight: {
      method: 'GET',
      url: "/api/histories/insight/:year/:month/:id",
      isArray: true
    },
    queryRecentActivities: {
      method: 'GET',
      url: "/api/histories/recent",
      isArray: true
    }
  });
}

export default angular.module('conduu.HistoryService', [])
  .factory('HistoryService', HistoryService)
  .name;



// WEBPACK FOOTER //
// ./client/components/history/history.service.js